export const getCurrentUTC = () =>
  new Date().toISOString().split(".")[0].replace("T", " ");
